import constants from '@/constants';
import { batchList } from '@/components/buyingOptionsPopup/BuyingOptionsPopup';
export const LANDING_PAGE_PARAMS_PAGE_TYPE = {
  GATEWAY: 1,
  LANDINGPAGE: 2,
  SECONDARY_ACTIVITY_PAGE: 4,
  HOME_PAGE: 'HomePage',
  LANDING_PAGE: 'LandingPage'
};

export const batchGetAsinsData = async (asinIds, spliceCount, asinList) => {
  if (!asinIds.length) return;
  const sliceAsinIds = asinIds.splice(0, spliceCount);
  const sliceAsinResults = await batchList(sliceAsinIds.join());
  const filterResults = sliceAsinResults.filter(
    i =>
      i.selectionEligible &&
      i.availability?.status !== constants.AVAILABILITY_STATUS_ENUM.OUT_OF_STOCK
  );
  asinList.value.push(...filterResults);
  batchGetAsinsData(asinIds, spliceCount, asinList);
};
